module.exports = __webpack_public_path__ + "img/IMG_1231_L_Foamcore.b81027ee.jpg";